import React from "react";

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children, className = "" }) => {
  return (
    <>
      <style>{`
        .tooltip-wrapper {
          position: relative;
          display: inline-block;
        }
        .tooltip-wrapper .tooltip-text {
          visibility: hidden;
          background-color: #222;
          color: #fff;
          text-align: center;
          border-radius: 6px;
          padding: 8px 12px;
          position: absolute;
          z-index: 1000;
          bottom: 125%;
          left: 50%;
          transform: translateX(-50%);
          opacity: 0;
          transition: opacity 0.3s;
          white-space: pre-wrap;
          font-size: 13px;
          width: 200px;
          min-width: 200px;
          word-break: break-word;
          overflow-wrap: break-word;
          line-height: 1.4;
        }
        .tooltip-wrapper .tooltip-text::after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #222 transparent transparent transparent;
        }
        .tooltip-wrapper:hover .tooltip-text {
          visibility: visible;
          opacity: 1;
        }
        .tooltip-trigger {
          color: #aa8453;
          text-decoration: underline;
          cursor: help;
        }
      `}</style>
      <span className={`tooltip-wrapper ${className}`}>
        <span className="tooltip-trigger">{children}</span>
        <span className="tooltip-text">{text}</span>
      </span>
    </>
  );
};

export default Tooltip;
